import { Box, Group, Select } from "@mantine/core";
import { DatePicker } from "@mantine/dates";

const DateFilter = ({
  timeRange,
  onTimeRangeChange,
  selectedStartDate,
  onStartDateChange,
  selectedEndDate,
  onEndDateChange,
}) => {
  return (
    <Box style={{ position: "relative", zIndex: 10000 }}>
      <Group
        justify="space-between"
        align="flex-start"
        style={{
          flexDirection: "row",
          flexWrap: "nowrap",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <Select
          style={{ minWidth: "140px" }}
          data={[
            { value: "DAILY", label: "Daily" },
            { value: "WEEKLY", label: "Weekly" },
            { value: "MONTHLY", label: "Monthly" },
            { value: "QUARTERLY", label: "Half Year" },
            { value: "YEARLY", label: "Yearly" },
          ]}
          value={timeRange}
          onChange={onTimeRangeChange}
          placeholder="Period"
          withinPortal
          clearable
        />

        <DatePicker
          style={{ minWidth: "140px" }}
          value={selectedStartDate}
          onChange={onStartDateChange}
          placeholder="Start Date"
          popoverProps={{ withinPortal: true, zIndex: 10001 }}
          clearable
        />

        <DatePicker
          style={{ minWidth: "140px" }}
          value={selectedEndDate}
          onChange={onEndDateChange}
          placeholder="End Date"
          popoverProps={{ withinPortal: true, zIndex: 10001 }}
          clearable
        />
      </Group>
    </Box>
  );
};

export default DateFilter;
